import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Landing from "@/pages/Landing";
import QRLanding from "@/pages/QRLanding";
import FoodBuddy from "@/pages/FoodBuddy";
import FoodCourtHome from "@/pages/FoodCourtHome";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Track from "@/pages/Track";
import Login from "@/pages/Login";
import AdminShell from "@/pages/admin/AdminShell";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#08183A] flex items-center justify-center text-amber-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/t/:tableCode" element={<QRLanding />} />
              <Route path="/order" element={<FoodBuddy />} />
              <Route path="/menu" element={<FoodCourtHome />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/track/:id" element={<Track />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin/*" element={<Protected><AdminShell /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
